export const CUSTOM_HEADER_HEIGHT = 64
export const CUSTOM_HEADER_HEIGHT_MOBILE = 52

export const KIWI_FONT_STACK = `'Circular Pro', -apple-system, '.SFNSText-Regular', 'San Francisco', 'Segoe UI', 'Helvetica Neue', 'Lucida Grande', sans-serif`
